import React, { useState } from 'react';
import theme from '../../styles/theme/theme';

const AuthButton = ({
  children,
  onClick,
  disabled,
  type = 'button',
  variant = 'contained',
  style = {},
  fullWidth = true,
}) => {
  const [isHovered, setIsHovered] = useState(false);

  const baseStyle = {
    width: fullWidth ? '100%' : 'auto',
    padding: theme.spacing(3), // 0.75rem
    borderRadius: theme.shape.borderRadius,
    fontWeight: theme.typography.button.fontWeight,
    fontSize: theme.typography.button.fontSize,
    textTransform: theme.typography.button.textTransform,
    cursor: disabled ? 'not-allowed' : 'pointer',
    opacity: disabled ? 0.6 : 1,
    transition: `all ${theme.transitions.duration.short}ms ${theme.transitions.easing.easeInOut}`,
  };

  const containedStyle = {
    backgroundColor: isHovered
      ? theme.palette.tertiary.main
      : theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    border: 'none',
  };

  const outlinedStyle = {
    backgroundColor: isHovered ? theme.palette.primary.main : '#fff',
    color: isHovered
      ? theme.palette.primary.contrastText
      : theme.palette.primary.main,
    border: `2px solid ${theme.palette.primary.main}`,
  };

  const finalStyle = {
    ...baseStyle,
    ...(variant === 'outlined' ? outlinedStyle : containedStyle),
    ...style,
  };

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={finalStyle}
    >
      {children}
    </button>
  );
};

export default AuthButton;
